import Images404404Svg from '@/public/images/404/404.svg';
import Images404Text404Svg from '@/public/images/404/text-404.svg';
import Images404WhiskyMissingWebp from '@/public/images/404/whiskyMissing.webp';

export { Images404404Svg, Images404Text404Svg, Images404WhiskyMissingWebp };
